var map = {
	"./1.jpg": 1101,
	"./10.jpg": 8529,
	"./11.jpg": 4,
	"./12.jpg": 1811,
	"./2.jpg": 1202,
	"./3.jpg": 9135,
	"./4.jpg": 1172,
	"./5.jpg": 9217,
	"./6.jpg": 3286,
	"./7.jpg": 6451,
	"./8.jpg": 8312,
	"./9.jpg": 677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2825;